/* eslint-disable max-len */
import types from '../types'
import 'firebase/compat/database'
import getDefaultData from './getDefaultData'
import {getCycleStart} from './getCycleStart'
import {runSteps} from './runSteps.js'

export const getModules = (database) => async (dispatch) => {
  // const dbRef = database.ref(`modules`)
  // await dbRef.on(
  //     'value',
  //     (snapshot) => {
  //       const val = snapshot.val()
  //       const modules = val
  //       dispatch({
  //         type: types.STORE_PAYLOAD,
  //         payload: {
  //           modules,
  //         },
  //       })
  //     },
  //     (errorObject) => console.log(errorObject),
  // )
  const modules = getDefaultData(getCycleStart(1))

  dispatch({
    type: types.STORE_PAYLOAD,
    payload: {
      modules,
    },
  })
  console.log(new Date(getCycleStart()).toLocaleString())
  console.log(new Date(getCycleStart(-1)).toLocaleString())
  setTimeout(() => {
    dispatch(runSteps())
  }, 0)
  const timeUntilNextCycle = getCycleStart(-1) - Date.now() + 10
  setTimeout(() => {
    dispatch(runSteps())
    setInterval(() => {
      dispatch(runSteps())
    }, 807500)
  }, timeUntilNextCycle)
}
